import styled from 'styled-components';
import primitives from '@veneer/primitives';

export const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  padding: ${primitives.layout.size4}px ${primitives.layout.size3}px;
  gap: ${primitives.layout.size3}px;
  min-height: 88px;
`;

export const IconContainer = styled.div`
  min-width: 48px;
  min-height: 48px;
  width: 48px;
  height: 48px;
  background: ${primitives.color.powerStorm0};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

`;

export const InfoContainer = styled.div`
  height: fit-content;
  flex: 1;
`;

export const WorkspaceName = styled.h3`
  margin-bottom: ${primitives.layout.size1}px;
`;

export const InfoItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${primitives.layout.size1}px;
  line-height: 1.4;
`;

export const InfoLabel = styled.span`
  color: ${primitives.color.gray7};
  white-space: nowrap;
`;

export const InfoValue = styled.span`
  word-break: break-word;
  flex: 1;
`;

export const AddonsWidgetContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
`;
